export type FieldType = 'string' | 'number' | 'nested';

export interface Field {
  key: string;
  type: FieldType;
  value?: string | number;
  children?: Field[];
}

export const FIELD_TYPES = [
  { label: 'String', value: 'string' },
  { label: 'Number', value: 'number' },
  { label: 'Nested', value: 'nested' },
];
